module.exports = __webpack_public_path__ + "assets/img/typeIcon-2-yellow.d6c2e4d2.svg";